var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "favouritesListLayout" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("span", { staticClass: "page-title" }, [_vm._v("My Favourites")])
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "back-col", attrs: { span: 12 } }, [
            _c(
              "span",
              {
                staticClass: "btn-back",
                on: {
                  click: function($event) {
                    return _vm.goBack()
                  }
                }
              },
              [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v("BACK")]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("el-row", [_c("el-divider")], 1),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _vm.dataValues == null ||
          _vm.dataValues == "" ||
          _vm.dataValues == undefined
            ? _c(
                "el-col",
                {
                  staticStyle: { display: "flex", "justify-content": "center" },
                  attrs: { span: 24 }
                },
                [
                  _vm.loading
                    ? _c("loading-skeleton")
                    : _c(
                        "span",
                        {
                          staticStyle: {
                            padding: "50px 0",
                            "font-size": "18px",
                            color: "#003333"
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Nothing here yet! Explore and mark your favourites for quick access\n                "
                          )
                        ]
                      )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.dataValues, function(item, index) {
            return _c(
              "el-col",
              {
                key: index,
                staticStyle: { "margin-top": "20px" },
                attrs: { span: 6 }
              },
              [
                _c("favourite-property-card", {
                  attrs: { property: item },
                  on: { removeFavourite: _vm.removeFavourite }
                })
              ],
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-792a294b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-792a294b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myFavourites/favouritesListLayout.vue
// module id = null
// module chunks = 